import http from "./http-common";

export const getVehicles = () => http.get(`/vehicles`)